import React from 'react';
import { GridActionsCellItem } from '@mui/x-data-grid-pro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { faChartSimple, faCircleXmark, faPenToSquare, faUsers } from '@fortawesome/pro-light-svg-icons';
import { NewsItemModel } from '../../../../api-service/clients';
import { TrashIcon } from '../../../../components/icons/trash-icon/trash-icon';
import { isStillVisible } from './news-item-visibility';

export type NewsItemTool = 'edit' | 'recipients' | 'statistics' | 'close' | 'delete';

export function newsItemTools(newsItem: NewsItemModel, canWrite: boolean, onToolClick: (tool: NewsItemTool, newsItem: NewsItemModel) => void) {
  function tool(kind: NewsItemTool, label: string, icon: React.ReactElement) {
    return (
      <GridActionsCellItem
        key={kind}
        label={label}
        title={label}
        icon={icon}
        onClick={() => onToolClick(kind, newsItem)}
        placeholder=""
        onPointerEnterCapture={undefined}
        onPointerLeaveCapture={undefined}
      />
    );
  }

  function iconOf(icon: IconDefinition) {
    return <FontAwesomeIcon icon={icon} />;
  }

  const mayChange = canWrite && newsItem.canDelete;

  return [
    tool('edit', 'Detaljer', iconOf(faPenToSquare)),
    tool('recipients', 'Vis nyhedsmodtagere', iconOf(faUsers)),
    tool('statistics', 'Vis statistik', iconOf(faChartSimple)),
    ...(mayChange && isStillVisible(newsItem) ? [tool('close', 'Luk nyhed', iconOf(faCircleXmark))] : []),
    ...(mayChange ? [tool('delete', 'Slet nyhed', <TrashIcon />)] : []),
  ];
}
